import { ComponentInterface } from "@stencil/core"

export const isArrowLeftKey = (e: KeyboardEvent) => e.key === "ArrowLeft" || e.key === "Left"
export const isArrowUpKey = (e: KeyboardEvent) => e.key === "ArrowUp" || e.key === "Up"
export const isArrowRightKey = (e: KeyboardEvent) => e.key === "ArrowRight" || e.key === "Right"
export const isArrowDownKey = (e: KeyboardEvent) => e.key === "ArrowDown" || e.key === "Down"
export const isArrowKey = (e: KeyboardEvent) =>
  isArrowDownKey(e) || isArrowRightKey(e) || isArrowUpKey(e) || isArrowLeftKey(e)
export const isEscapeKey = (e: KeyboardEvent) => e.key === "Escape" || e.key === "Esc"
export const isShiftTabKey = (e: KeyboardEvent) => e.shiftKey && e.key === "Tab"
export const isTabKey = (e: KeyboardEvent) => e.key === "Tab"
export const isBackspaceKey = (e: KeyboardEvent) => e.key === "Backspace"
export const isSpaceKey = (e: KeyboardEvent) => e.key === " " || e.key === "Spacebar"
export const isPlusKey = (e: KeyboardEvent) => e.key === "+" || e.key === "Add"
export const isMinusKey = (e: KeyboardEvent) => e.key === "-" || e.key === "Subtract"
export const isQuestionKey = (e: KeyboardEvent) => e.key === "?"
export const isEnterKey = (e: KeyboardEvent) => e.key === "Enter"
export const isKeyboardClick = (e: KeyboardEvent) => isEnterKey(e) || isSpaceKey(e)
export const isNumber = (e: KeyboardEvent) => e.key >= "0" && e.key <= "9"

/**
 * Component instances that have subscribed to tabbing change.
 */
const tabbingChangeSubscribers: Set<ComponentInterface> = new Set()
function notifySubscribers(tabbing: boolean) {
  tabbingChangeSubscribers.forEach(subscriber => {
    subscriber.element.classList[tabbing ? "add" : "remove"]("user-is-tabbing")
  })
}
function listenKeys(event: KeyboardEvent) {
  if (isTabKey(event)) {
    notifySubscribers(true)
    window.removeEventListener("keydown", listenKeys)
    window.addEventListener("mousedown", listenMouse, false)
  }
}
function listenMouse() {
  notifySubscribers(false)
  window.removeEventListener("mousedown", listenMouse)
  window.addEventListener("keydown", listenKeys, false)
}
// start listening for mouse clicking (and tabbing through that) only if window is defined (i.e. not on server)
if (typeof window !== "undefined") {
  window.addEventListener("mousedown", listenMouse, false)
  // on blur, leave the window in tabbing state
  window.addEventListener("blur", () => listenKeys({ key: "Tab" } as KeyboardEvent))
}
export const subscribeTabbingChange = component => {
  tabbingChangeSubscribers.add(component)
  component.element.classList.add("user-is-tabbing")
}
export const unsubscribeTabbingChange = component => {
  tabbingChangeSubscribers.delete(component)
}
export const enableUserIsTabbing = () => {
  listenKeys({ key: "Tab" } as KeyboardEvent)
}
